import {
  CoreHotelCfarOffersComponents,
  CORE_HOTELS_CFAR_NAME,
} from "@b2bportal/core-types";
import HtsLodgingCfarFintechMarketplaceProductStyles from "./HtsLodgingCfarFintechMarketplaceProduct.module.scss";
import LodgingCfarSyntheticRateBaseStyles from "./LodgingCfarSyntheticRateBase.module.scss";

export const CORE_HOTELS_CFAR_STYLE_OVERRIDES = {
  [CORE_HOTELS_CFAR_NAME]: {
    [CoreHotelCfarOffersComponents.LodgingCfarSyntheticRateBase]:
      LodgingCfarSyntheticRateBaseStyles,
    [CoreHotelCfarOffersComponents.HtsLodgingCfarFintechMarketplaceProduct]:
      HtsLodgingCfarFintechMarketplaceProductStyles,
  },
};
